<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_export_servicios_nacionales"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Generar Listado Servicios Nacionales
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTabNac" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas-nac"
                  data-toggle="tab"
                  href="#ColumnasNac"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros-nac"
                  data-toggle="tab"
                  href="#FiltrosNac"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContentNac">
              <div class="tab-pane" id="FiltrosNac">
                <div class="card-body">
                  <div class="form-group row">
                    <div class="form-group col-md-6">
                      <label for="">Fecha Inicial</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_ini"
                        @input="validaFechas"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="">Fecha Final</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_fin"
                        @input="validaFechas"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="" class="col-md-5">N° Servicio</label>
                    <input
                      type="number"
                      id="id_nac"
                      v-model="filtros.id"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="" class="col-md-5">Placa</label>
                    <input
                      type="text"
                      id="placa_nac"
                      v-model="filtros.placa"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="" class="col-md-5">Empresa</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="empresa"
                      placeholder="Empresa"
                      label="razon_social"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.empresas"
                      :filterable="true"
                      @search="buscarEmpresas"
                      @input="getSelectEmpresa()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="" class="col-md-5"> Estado</label>
                    <select
                      id="estado_nac"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="ColumnasNac">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="id1_nac"
                            v-model="form.id"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="id1_nac"
                            >N° Servicio</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="vh_equi_nac"
                            v-model="form.vh_equi"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="vh_equi_nac"
                            >Vehículo / Equipo</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="placa_col_nac"
                            v-model="form.placa"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="placa_col_nac"
                            >Placa</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="persona_nac"
                            v-model="form.persona"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="persona_nac"
                            >Tipo Persona</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="nombre1_nac"
                            v-model="form.nombre"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="nombre1_nac"
                            >Nombre</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="remolque_nac"
                            v-model="form.remolque"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="remolque_nac"
                            >Remolque</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="tipo_servicio1_nac"
                            v-model="form.tipo_servicio"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="tipo_servicio1_nac"
                            >Tipo Servicio</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="fecha_ini1_nac"
                            v-model="form.fecha_ini"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="fecha_ini1_nac"
                            >Fecha Inicial</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="fecha_fin1_nac"
                            v-model="form.fecha_fin"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="fecha_fin1_nac"
                            >Fecha Final</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="empresa_nac"
                            v-model="form.empresa"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="empresa_nac"
                            >Empresa</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="trabajo_realizado_nac"
                            v-model="form.trabajo_realizado"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="trabajo_realizado_nac"
                            >Trabajo Realizado</label
                          >
                        </div>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id="estado1_nac"
                            v-model="form.estado"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="estado1_nac"
                            >Estado</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "CsServicioExport",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      empresa: {},
      form: {
        id: true,
        vh_equi: true,
        placa: true,
        persona: true,
        nombre: true,
        remolque: true,
        tipo_servicio: true,
        fecha_ini: true,
        fecha_fin: true,
        empresa: true,
        trabajo_realizado: true,
        estado: true,
      },
      filtros: {
        id: null,
        placa: null,
        empresa_id: null,
        fecha_ini: null,
        fecha_fin: null,
        estado: null,
      },
      listasForms: {
        empresas: [],
        estados: [],
      },
    };
  },
  validations: {},
  methods: {
    getEstados() {
      axios.get("/api/lista/239").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    async buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        await axios
          .get("api/admin/empresas/lista?razon=" + search, {
            params: { linea_negocio_id: [4] },
          })
          .then(function(response) {
            me.listasForms.empresas = response.data;
            loading(false);
          })
          .catch(function(error) {
            me.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    getSelectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
    },
    validaFechas() {
      if (this.filtros.fecha_ini && this.filtros.fecha_fin) {
        var fecha_menor = new Date(this.filtros.fecha_ini);
        var fecha_mayor = new Date(this.filtros.fecha_fin);
        if (fecha_menor > fecha_mayor) {
          this.filtros.fecha_fin = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial no puede ser mayor a la fecha final...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },
    limpiarExport() {
      this.filtros = {
        id: null,
        placa: null,
        empresa_id: null,
        fecha_ini: null,
        fecha_fin: null,
        estado: null,
      };
      this.empresa = [];
    },
    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/cs/serviciosNacionales/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
          this.$swal({
            icon: "success",
            title: response.data.message,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
  async mounted() {
    this.cargando = true;
    await this.getEstados();
    this.cargando = false;
  },
};
</script>
